import React, { useState, useEffect } from 'react';
import { Menu, X } from 'lucide-react';
import { navigationItems } from '../mockData';

const Header = ({ onOpenModal }) => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-white shadow-md' : 'bg-white/95'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 py-4 flex items-center justify-between">
        {/* Logo */}
        <a href="#" className="flex-shrink-0">
          <div className="flex items-baseline border border-black px-3 py-1">
            <span className="text-3xl md:text-4xl font-black tracking-tighter text-black">MK</span>
            <span className="text-3xl md:text-4xl font-extralight tracking-tighter text-black">118</span>
          </div>
        </a>

        {/* Desktop Navigation */}
        <nav className="hidden md:flex items-center space-x-8">
          {navigationItems.map((item) => (
            <a
              key={item.id}
              href={item.href}
              className="text-base md:text-lg font-medium text-gray-900 hover:text-gray-600 transition-colors"
            >
              {item.label}
            </a>
          ))}
        </nav>

        {/* CTA Button */}
        <button
          onClick={onOpenModal}
          className="hidden md:block bg-black text-white px-6 py-2.5 text-sm font-medium hover:bg-gray-800 transition-colors"
        >
          Mietanfrage
        </button>

        {/* Mobile Menu Button */}
        <button
          onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          className="md:hidden p-2"
        >
          {isMobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
        </button>
      </div>

      {/* Mobile Menu */}
      {isMobileMenuOpen && (
        <div className="md:hidden bg-white border-t">
          <nav className="flex flex-col px-6 py-4 space-y-4">
            {navigationItems.map((item) => (
              <a
                key={item.id}
                href={item.href}
                className="text-base font-medium text-gray-900 hover:text-gray-600 transition-colors"
                onClick={() => setIsMobileMenuOpen(false)}
              >
                {item.label}
              </a>
            ))}
            <button
              onClick={() => {
                onOpenModal();
                setIsMobileMenuOpen(false);
              }}
              className="bg-black text-white px-6 py-2.5 text-sm font-medium hover:bg-gray-800 transition-colors w-full"
            >
              Mietanfrage
            </button>
          </nav>
        </div>
      )}
    </header>
  );
};

export default Header;